module.exports = __webpack_public_path__ + "static/img/signin_bg.ab699f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/signin_bg.png
// module id = rYIS
// module chunks = 1